import axios from "axios";


import { ENDPOINTS } from "../jsx/services/ENDPOINT";

const BASE_URL = `${ENDPOINTS.BASE_2}/suppliers`;

// Get all suppliers
export const getSuppliers = async () => {
  return await axios.get(BASE_URL);
};

// Create supplier
export const createSupplier = async (data) => {
  return await axios.post(BASE_URL, data);
};

// Update supplier
export const updateSupplier = async (id, data) => {
  return await axios.put(`${BASE_URL}/${id}`, data);
};

// Delete supplier
export const deleteSupplier = async (id) => {
  return await axios.delete(`${BASE_URL}/${id}`);
};